import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { GetDocumentFromDocumentum } from '@/interfaces/documents';
import { DocumentumService } from '@/services/documentum/documentum.service';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

interface BackError {
  httpCode: number;
  httpMessage: string;
  httpUserFriendlyError: string;
}

@Component({
  selector: 'app-download-document[driverMdmId][requirementId][assetId][documentId][documentName]',
  templateUrl: './download-document.component.html',
  styleUrls: ['./download-document.component.css'],
})
export class DownloadDocumentComponent implements OnInit {

  @Input() driverMdmId!: string;
  @Input() requirementId!: number;
  @Input() assetId!: number;
  @Input() documentId!: number;
  @Input() documentName!: string;

  errorText: string = '';
  shouldShowLoadingAnimation: boolean = false;

  constructor(
    private documentumService: DocumentumService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
  }

  downloadDocument(): void {
    const params: GetDocumentFromDocumentum = {
      mdmid: this.driverMdmId,
      requirementId: this.requirementId,
      documentId: this.documentId,
      assetId: this.assetId,
    };
    this.shouldShowLoadingAnimation = true;

    this.documentumService.downloadDocumentFile(params).subscribe({
      next: (blob) => {
        this.showSaveAlert(blob);
        this.shouldShowLoadingAnimation = false;
        this.cdr.detectChanges();
      },
      error: (httpError) => {
        parseErrorBlob(httpError, 'JSON').subscribe({
          next: (backError: BackError) => {
            let errorText = 'Hubo un error en la conexión con DLMS';
            if (backError.httpMessage) {
              if (backError.httpMessage.includes('FILE:NOT_FOUND - No file was found under the given parameters.')) {
                errorText = 'Hubo un error en la conexión a documentum';
              }
              if (backError.httpMessage.includes('File was deleted by TTL expired.')) {
                errorText = 'El documento no está disponbile, han pasado más de 30 dias desde que fue subido al sistema.';
              }
            }
            this.shouldShowLoadingAnimation = false;
            this.errorText = errorText;
            this.cdr.detectChanges();
            setTimeout(() => {
              this.errorText = '';
              this.cdr.detectChanges();
            }, 1000 * 10);
          },
        });
      },
    });
  }

  showSaveAlert(blob: Blob): void {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = this.documentName;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }
}

function parseErrorBlob(err: HttpErrorResponse, type: 'JSON' | 'text'): Observable<any> {
  const reader: FileReader = new FileReader();

  const obs = Observable.create((observer: any) => {
    reader.onloadend = () => {
      if (type === 'text') {
        observer.next(reader.result);
      }
      else if (type === 'JSON') {
        if (typeof reader.result === 'string') {
          observer.next(JSON.parse(reader.result));
        }
      }
      observer.complete();
    };
  });
  reader.readAsText(err.error);
  return obs;
}
